import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Input } from '@ui/components/Input/Input'
import { CopyIcon } from '@ui/icons/Copy.icon'

import { useCopy } from '@hooks/useCopy'

interface Props {
  isLinkLoading: boolean
  value: string
  label?: string
}

export const PromoUrlOutputInput: FC<Props> = ({ isLinkLoading, value, label }) => {
  const { t } = useTranslation()
  const { copy } = useCopy()
  const copyLabel = t('Copied!')

  return (
    <Input
      rightIcon={CopyIcon}
      onEndIconClick={() => copy(value, copyLabel)}
      value={value}
      label={label}
      size='lg'
      disabled={isLinkLoading}
    />
  )
}
